'use client';

/**
 * ValvulaSVG - Representación técnica de una válvula (estilo mariposa P&ID).
 * Permite interacción directa sobre el esquema SVG.
 */

type ValvulaProps = {
  x: number;
  y: number;
  abierta: boolean;
  label: string;
  onClick: () => void;
  bloqueada?: boolean;
  labelPos?: 'right' | 'below' | 'above'; // posición del label, por defecto 'right'
};

export default function ValvulaSVG({ 
  x, y, abierta, label, onClick, bloqueada = false, labelPos = 'right' 
}: ValvulaProps) {
  
  // Paleta de estados técnicos:
  // Bloqueada: Slate | Abierta: Green-500 | Cerrada: Red-500
  const color  = bloqueada ? '#64748b' : abierta ? '#22c55e' : '#ef4444';
  const stroke = bloqueada ? '#475569' : abierta ? '#16a34a' : '#dc2626';

  // Lógica de posicionamiento de etiquetas
  const labelX = labelPos === 'right' ? x + 18 : x;
  const labelY = labelPos === 'below' ? y + 26 : labelPos === 'above' ? y - 16 : y + 4;
  const labelAnchor = labelPos === 'right' ? 'start' : 'middle';

  return (
    <g
      onClick={bloqueada ? undefined : onClick}
      style={{ 
        cursor: bloqueada ? 'not-allowed' : 'pointer', 
        userSelect: 'none',
        transition: 'all 0.2s ease' // Transición suave de color
      }}
      opacity={bloqueada ? 0.5 : 1}
    >
      {/* Triángulo Superior */}
      <polygon 
        points={`${x},${y - 10} ${x + 14},${y + 10} ${x - 14},${y + 10}`} 
        fill={color} 
        stroke={stroke} 
        strokeWidth="1.5" 
      />
      {/* Triángulo Inferior */}
      <polygon 
        points={`${x},${y + 10} ${x + 14},${y - 10} ${x - 14},${y - 10}`} 
        fill={color} 
        stroke={stroke} 
        strokeWidth="1.5" 
      />

      {/* Indicador visual de bloqueo */}
      {bloqueada && (
        <text 
          x={x} 
          y={y + 4} 
          fill="white" 
          fontSize="10" 
          fontWeight="bold" 
          textAnchor="middle"
        >
          ×
        </text>
      )}

      {/* Etiqueta (V1, V2, etc.) */}
      <text 
        x={labelX} 
        y={labelY} 
        fill="#64748b" // slate-500
        fontSize="10" 
        fontFamily="monospace" 
        fontWeight="bold"
        textAnchor={labelAnchor}
      >
        {label}
      </text>

      {/* Área de interacción aumentada (invisible) para facilitar el click */}
      <circle cx={x} cy={y} r="18" fill="transparent" />
    </g>
  );
}